export const SLIDE_TRANSITION_MS = 300;
export const SPACE_FADE_MS = 400;
export const STAGGER_MS = 80;
